import React, { useRef, useState } from "react";
import styles from "./ModalStyle.module.scss";
import close from "../../assets/icons/closeModal.svg";
import back from "../../assets/icons/back.svg";
import mailBox from "../../assets/icons/mailBox.svg";
import { useDispatch } from "react-redux";
import { register, verifyOtpCode } from "../../redux/slices/authSlice";
const VerifyModal = ({ handleClose, handleVerify, data }) => {
  const [values, setValues] = useState(["", "", "", "", "", ""]);
  const inputs = useRef([]);
  const [otp, setOtp] = useState("");
  const [errorMsg,setErrorMsg]=useState('')
  const dispatch = useDispatch();
  const handleChange = (index, event) => {
    const value = event.target.value;
    if (/^\d$/.test(value)) {
      const newValues = [...values];
      newValues[index] = value;
      setValues(newValues);
      if (index < 5) {
        inputs.current[index + 1].focus();
      }
      if (index === 5) {
        const final = newValues.join("");
        setOtp(final);
        const updated = {
          ...data,
          otp: final,
        };
        const response = dispatch(verifyOtpCode(updated));
console.log(response);
response?.success?(handleVerify&&setErrorMsg('')):setErrorMsg(response?.message)

        // const response =  dispatch(verifyOtpCode({ email, otp,password,paswordConfirm }));
        // handleClose();
      }
    } else if (value === "") {
      const newValues = [...values];
      newValues[index] = "";
      setValues(newValues);
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && index > 0 && values[index] === "") {
      inputs.current[index - 1].focus(); // Geri qayıtma
    }
  };
  const tryAgain = async (e) => {
    e.preventDefault();
    // const response = await dispatch(register({ email }));
    // console.log(response);
  };

  return (
    <div className={styles.modal}>
      <div className={styles.top}>
        <span onClick={handleVerify}>
          <img src={back} alt="" /> Back
        </span>
        <div onClick={handleClose}>
          <img src={close} alt="" />
        </div>
      </div>
      <p>{errorMsg}</p>
      <div className={styles.content}>
        <h1>Verify your account</h1>
        <p>
          Enter the verification code we sent over to
          <br />
          <span>{data.email}</span>
        </p>
      </div>
      <div className={styles.inputContainer}>
        {values.map((value, index) => (
          <input
            key={index}
            type="text"
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            ref={(input) => (inputs.current[index] = input)}
            className={styles.verifyInput}
          />
        ))}
      </div>
      <a href={`mailto:${data.email}`} target="_blank">
        <div className={styles.mailBoxBtn}>
          <button>
            {" "}
            <img src={mailBox} alt="" />
            Open in mailbox{" "}
          </button>
        </div>
      </a>
      <p className={styles.changeText}>
        Didn’t receive the code?
        <span onClick={tryAgain}>Try again</span>
      </p>
      <br />
      <br />
    </div>
  );
};

export default VerifyModal;
